var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-category-icon",style:(_vm.iconBallStyle)},[_c('SvgIcon',{attrs:{"data":_vm.moduleCategory.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }